import React from 'react';
import { useTranslation } from 'react-i18next';
import { FuelingTransactionViewType } from '../enums/fuelingTransactionViewType';
import TabsNavigation from 'features/shared/components/navs/TabsNavigation';
import Tab from 'features/shared/components/navs/Tab';

type Props = {
  selectedViewType: FuelingTransactionViewType;
  setSelectedViewType: React.Dispatch<React.SetStateAction<FuelingTransactionViewType>>;
}

const FuelingSummaryDetailTabs = ({ selectedViewType, setSelectedViewType }: Props) => {
  // translations
  const tViewTypes = useTranslation("fueling\\enums\\fuelingTransactionViewType").t;

  // sub-renders
  const renderTabs = () => {
    let result: JSX.Element[] = [];
    const viewTypes: FuelingTransactionViewType[] = ["FuelingCard", "Station", "FuelingCustomer"]; 

    for (const viewType of viewTypes) {
      let tab = renderTab(viewType);
      result.push(tab);
    }

    return result;
  }

  const renderTab = (viewType: FuelingTransactionViewType) => { 
    return (
      <Tab 
          onClick={() => setSelectedViewType(viewType)} 
          active={selectedViewType == viewType}
          className="px-4 py-1"
        >
          {tViewTypes(viewType)}
      </Tab>
    );
  }

  // render
  return (
    <TabsNavigation>
      {renderTabs()}
    </TabsNavigation>
  )
}

export default FuelingSummaryDetailTabs;